import gql from 'graphql-tag';

const Query = {
  opportunityPreAssigment: gql`
    query opportunityAssigment($id: Int!) {
      opportunityAssigment(id: $id) {
        id
        opportunity {
          id
          type
          agentAssignmentId
          originLeadType
          sellingProject
          buyingProject
          isPrestigeEstimate
          callcenter {
            id
            temp
          }
          appointments {
            id
          }
          owners {
            id
            resideType
            name
            firstname
            phone_valid_number
            phone_valid_lookup
          }
          sources {
            id
            source
            referer
            section
          }
          estimations {
            id
            price
            maxPrice
            minPrice
          }
          property {
            id
            type
            propertiesType {
              id
              code
              name
            }
            nb_rooms
            nb_bedrooms
            nb_bathrooms
            year
            surface
            surface_land
            city
            zipcode
            region
            department
            region
            exposure
          }
          score {
            id
            star
            value
          }
          leadMeeting {
            id
            message
            week
            weekend
          }
        }
        externalLeadId
        contactsInfo {
          id
          name
          firstname
        }
        startAffectation
        endAffectation
        externalAffaireId
        externalAffaireUrl
        billingType
        isOpportunityAssigned
        taken
        rejected
      }
    }
  `,
  opportunityAssigment: gql`
    query opportunityAssigment($id: Int!) {
      opportunityAssigment(id: $id) {
        id
        opportunity {
          id
          type
          originLeadType
          createdAt
          callcenter {
            id
            temp
            transcriptUrl
          }
          appointments {
            id
            start
            end
            location
          }
          owners {
            id
            resideType
            phone
            name
            firstname
            contact {
              id
              email
            }
          }
          sources {
            id
            referer
          }
          estimations {
            id
            price
            maxPrice
            minPrice
            leadEstimationPrice
            leadEstimationThought
            leadEstimationReason
          }
          property {
            id
            type
            description
            latitude
            longitude
            nb_rooms
            nb_bedrooms
            nb_bathrooms
            garage_box
            has_swimming_pool
            floor
            number_floor
            elevator
            balcony_terrace_surface
            has_balcony_terrace
            number_levels_habitable
            cellar_surface
            year
            surface
            surface_land
            address
            street_number
            city
            zipcode
            region
            department
            region
            exposure
            propertiesType {
              id
              code
              name
            }
          }
          score {
            id
            star
            value
          }
        }
        externalLeadId
        contactsInfo {
          id
          phone_valid_number
          phone_valid_lookup
          phone_type
        }
        startAffectation
        endAffectation
        externalAffaireId
        externalAffaireUrl
        billingType
        isOpportunityAssigned
        taken
        rejected
        leadUnreachable
        leadWrongNumber
        leadNotInterested
        leadToContactLater
        leadWantsAppointment
        leadMandat
        leadComment
        leadStatut
      }
    }
  `,
};

const Mutation = {
  setStatutLead: gql`
    mutation setStatutLead($opportunityAssignmentId: Int!, $statutLead: StatutLeadInput!) {
      setStatutLead(opportunityAssignmentId: $opportunityAssignmentId, statutLead: $statutLead) {
        id
        leadUnreachable
        leadWrongNumber
        leadNotInterested
        leadToContactLater
        leadWantsAppointment
        leadMandat
        leadComment
        leadStatut
      }
    }
  `,
};

export default {
  Query,
  Mutation,
};
